import { connect } from 'react-redux'
import Insights from './Insights'

import selectIsFiltered from './Selectors/selectIsFiltered'
import selectIsClickableRow from './Selectors/selectIsClickableRow'

import componentDidMount from './Handlers/componentDidMount'
import onChangeSetup from './Handlers/onChangeSetup'
import onChangeFilter from './Handlers/onChangeFilter'
import onChangeSearch from './Handlers/onChangeSearch'
import onSubmitSearch from './Handlers/onSubmitSearch'
import onChangeSort from './Handlers/onChangeSort'
import onClickExport from './Handlers/onClickExport'
import onClickRow from './Handlers/onClickRow'
import onCloseTimesheetsDrawer from './Handlers/onCloseTimesheetsDrawer'

const mapStateToProps = (state) => ({
  projectStatuses: state.core.projectStatuses,
  projectPhases: state.core.projectPhases,
  clients: state.core.clients,
  users: state.core.users,
  subcontractors: state.core.subcontractors,
  projects: state.core.projects,
  setup: state.screens.Insights.setup,
  filters: state.screens.Insights.filters,
  searchTerm: state.screens.Insights.searchTerm,
  sortBy: state.screens.Insights.sortBy,
  data: state.screens.Insights.data,
  fetching: state.screens.Insights.fetching,
  isFiltered: selectIsFiltered(state),
  isClickableRow: selectIsClickableRow(state),
  timesheetsDrawer: state.screens.Insights.timesheetsDrawer,
})

const actionCreators = {
  componentDidMount,
  onChangeSetup,
  onChangeFilter,
  onChangeSearch,
  onSubmitSearch,
  onChangeSort,
  onClickExport,
  onClickRow,
  onCloseTimesheetsDrawer,
}

export default connect(mapStateToProps, actionCreators)(Insights)
